(() => {
  const MEDIA_ORDER = [
    '43588988666140',
    '43588988731676',
    '43588989124892',
    '43588988961052',
    '43588988829980',
    '43588960780572',
    '43588961173788',
    '43588961272092',
    '43588961337628'
  ];
  const MEDIA_ALT = {
    '43588988666140': 'BLACK ROSE Tee actual garment, front view.',
    '43588988731676': 'BLACK ROSE Tee actual garment, back view.',
    '43588989124892': 'BLACK ROSE Tee back rose print detail.',
    '43588988961052': 'BLACK ROSE Tee front chest print detail.',
    '43588988829980': 'BLACK ROSE Tee collar and heavyweight construction detail.',
    '43588960780572': 'David wearing BLACK ROSE Tee in a gym.',
    '43588961173788': 'David wearing BLACK ROSE Tee, alternate view.',
    '43588961272092': 'David wearing BLACK ROSE Tee, alternate view.',
    '43588961337628': 'David wearing BLACK ROSE Tee, alternate view.'
  };

  const section = document.querySelector('.black-rose-ready-mto');
  if (!section) return;

  const statusRegion = section.querySelector('[data-black-rose-shipping-status]');
  const status = statusRegion && statusRegion.querySelector('[data-shipping-status]');
  const statusLabel = statusRegion && statusRegion.querySelector('[data-status-label]');
  const statusCopy = statusRegion && statusRegion.querySelector('[data-status-copy]');
  const readyMapElement = statusRegion && statusRegion.querySelector('[data-black-rose-ready-map]');

  let readyBySize = {};
  if (readyMapElement) {
    try {
      readyBySize = JSON.parse(readyMapElement.textContent || '{}');
    } catch (error) {
      readyBySize = {};
    }
  }

  const setFulfillmentDetail = (copy) => {
    const detail = section.querySelector('[data-black-rose-fulfillment-detail]');
    if (detail && detail.textContent !== copy) detail.textContent = copy;
  };

  const selectedSize = () => {
    const input = Array.from(section.querySelectorAll('input[type="radio"]:checked'))
      .find((candidate) => ['XS', 'S', 'M', 'L', 'XL', '2XL'].includes(candidate.value));
    return input ? input.value : '';
  };

  const setLineItemProperty = (state, readyStock) => {
    section.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      let fulfillmentInput = form.querySelector('input[name="properties[_abc_fulfillment]"]');
      if (!fulfillmentInput) {
        fulfillmentInput = document.createElement('input');
        fulfillmentInput.type = 'hidden';
        fulfillmentInput.name = 'properties[_abc_fulfillment]';
        form.appendChild(fulfillmentInput);
      }
      fulfillmentInput.value = state;

      let readyInput = form.querySelector('input[name="properties[_abc_ready_stock_at_selection]"]');
      if (!readyInput) {
        readyInput = document.createElement('input');
        readyInput.type = 'hidden';
        readyInput.name = 'properties[_abc_ready_stock_at_selection]';
        form.appendChild(readyInput);
      }
      readyInput.value = String(readyStock);
    });
  };

  const syncSelectedVariant = (size) => {
    const selectedVariant = readyBySize[size];
    if (!selectedVariant || selectedVariant.available !== true) return;

    const expectedVariantId = String(selectedVariant.variantId);
    section.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;
      variantInput.value = expectedVariantId;
      variantInput.disabled = false;
    });
  };

  const renderShippingState = () => {
    if (!status || !statusLabel || !statusCopy) return;

    const size = selectedSize();
    if (size) syncSelectedVariant(size);

    const mtoLabel = statusRegion.dataset.mtoLabel;
    const mtoCopy = statusRegion.dataset.mtoCopy;
    const mtoDetail = statusRegion.dataset.mtoDetail;
    if (!mtoLabel || !mtoCopy || !mtoDetail) return;

    status.dataset.state = 'mto';
    statusLabel.textContent = mtoLabel;
    statusCopy.textContent = mtoCopy;
    setFulfillmentDetail(mtoDetail);
    setLineItemProperty('made_to_order', 0);
  };

  const isQuantityInput = (target) =>
    target instanceof HTMLInputElement
    && (target.name === 'quantity' || target.classList.contains('quantity__input'));

  section.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"]')) {
      renderShippingState();
      requestAnimationFrame(renderShippingState);
      [0, 100, 300, 700, 1200].forEach((delay) => {
        window.setTimeout(renderShippingState, delay);
      });
      return;
    }
    if (isQuantityInput(event.target)) renderShippingState();
  });

  section.addEventListener('input', (event) => {
    if (isQuantityInput(event.target)) renderShippingState();
  });

  section.addEventListener('click', (event) => {
    if (event.target.closest('quantity-input button, .quantity__button')) {
      window.setTimeout(renderShippingState, 0);
    }
  });

  const mediaIdOf = (node) => {
    const raw = node.dataset.mediaId || node.dataset.target || '';
    return MEDIA_ORDER.find((id) => raw.endsWith('-' + id) || raw === id) || '';
  };

  const reorderList = (list, selector) => {
    if (!list) return;
    const nodes = Array.from(list.querySelectorAll(':scope > ' + selector));
    const byId = new Map(nodes.map((node) => [mediaIdOf(node), node]));
    MEDIA_ORDER.forEach((id) => {
      const node = byId.get(id);
      if (node) list.appendChild(node);
    });
  };

  const improveMediaAlt = () => {
    section.querySelectorAll('[data-media-id]').forEach((node) => {
      const id = mediaIdOf(node);
      const img = node.querySelector('img');
      if (img && id && MEDIA_ALT[id]) img.alt = MEDIA_ALT[id];
    });
  };

  const reorderProductEvidence = () => {
    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;

    const viewer = gallery.querySelector('[id^="Slider-Gallery-"]');
    reorderList(viewer, 'li[data-media-id]');

    const thumbnails = gallery.querySelector('ul.thumbnail-list');
    reorderList(thumbnails, 'li[data-target]');

    improveMediaAlt();

    const frontId = MEDIA_ORDER[0];
    const frontNode = Array.from(gallery.querySelectorAll('[data-media-id]'))
      .find((node) => mediaIdOf(node) === frontId);
    gallery.querySelectorAll('.product__media-item.is-active').forEach((node) => node.classList.remove('is-active'));
    if (frontNode) frontNode.classList.add('is-active');

    if (typeof gallery.setActiveMedia === 'function' && frontNode) {
      gallery.setActiveMedia(frontNode.dataset.mediaId, false);
    }
  };

  renderShippingState();
  reorderProductEvidence();

  requestAnimationFrame(() => {
    renderShippingState();
    reorderProductEvidence();
  });

  window.setTimeout(() => {
    renderShippingState();
    reorderProductEvidence();
  }, 400);

})();
